/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface OrganisationIdentifierDto {
    /**
     * The integration identifier
     */
    integration: OrganisationIdentifierDto.Integration;
    /**
     * The user\'s identifier
     */
    identifier: string;
}
export namespace OrganisationIdentifierDto {
    export type Integration = 'ASA';
    export const Integration = {
        ASA: 'ASA' as Integration
    };
}
